Ply.AllocationWizardWishlistStep = function(el, options) {
    Ply.AllocationWizardStep.call(this, el, options);

    this.dom.skipButton = this.dom.el.querySelector("[data-wishlist-skip]");
    this.dom.checkoutButton = this.dom.el.querySelector("[data-checkout]");
    this.editButtons = Ply.makeArray(this.dom.el.querySelectorAll("[data-allocation-select]"));

    this.initQuantity = this.initQuantity.bind(this);
    this.handleSkipButtonClick = this.handleSkipButtonClick.bind(this);
    this.handleCheckoutButtonClick = this.handleCheckoutButtonClick.bind(this);

    this.quantities = Ply.makeArray(this.dom.el.querySelectorAll("[data-wishlist-quantity]")).map(this.initQuantity);

    this.dom.skipButton.addEventListener('click', this.handleSkipButtonClick);
    this.dom.checkoutButton.addEventListener('click', this.handleCheckoutButtonClick);

    this.editButtons.map(function(el) {
        el.addEventListener("click", this.options.onBackButtonClick);
    }.bind(this));
};

Ply.AllocationWizardWishlistStep.prototype = Object.create(Ply.AllocationWizardStep.prototype);
Ply.AllocationWizardWishlistStep.prototype.constructor = Ply.AllocationWizardWishlistStep;

Ply.AllocationWizardWishlistStep.prototype.render = function() {
    this.quantities.forEach(function(quantity, i) {
        quantity.render();
    });
    Ply.makeArray(this.dom.el.querySelectorAll("[data-selected-product]")).forEach(function(el) {
        el.style.display = el.dataset.selectedProduct === this.options.props.selectedProductHandle ? "" : "none";
    }.bind(this));
    Ply.AllocationWizardStep.prototype.render.call(this);
};

Ply.AllocationWizardWishlistStep.prototype.initQuantity = function(el, i) {
    return new Ply.AllocationWishlistQuantity(el, {
        props: this.options.props,
        onChange: this.options.onQuantityChange
    });
};

Ply.AllocationWizardWishlistStep.prototype.hasWishlistItems = function() {
    return this.options.props.wishlistItems.some(function(item) { return parseInt(item.quantity) > 0 });
};

Ply.AllocationWizardWishlistStep.prototype.handleSkipButtonClick = function(event) {
    this.disableButtons();
    event.target.innerHTML = this.buttonSubmittingText();
    this.options.onSkipButtonClick(event);
};

Ply.AllocationWizardWishlistStep.prototype.handleCheckoutButtonClick = function(event) {
    this.disableButtons();
    event.target.innerHTML = this.buttonSubmittingText();
    this.options.onCheckoutButtonClick(event);
};
